import { OptionRecord } from "./OptionRecord";

// На самом деле мы поддерживаем любые строковые идентификаторы
// Но аналитики захотели, чтобы это были числа, которые генерируются автоматически:
// Цитата из требований (http://wiki.d4r.int/pages/viewpage.action?pageId=514856982&spaceKey=MDM20&title=%D0%90%D1%82%D1%80%D0%B8%D0%B1%D1%83%D1%82%D1%8B)
//   * Тип данных: number
//   * Обязательное поле
//   * Нередактируемое, заполняется автоматически
// Поэтому данная функция находит id[N+1] = max(id[i]) + 1

export const makeNewOptionId = (options: OptionRecord[]): string => {
  let maxNumId: number | undefined;
  options.forEach(({ id }) => {
    const numId = +id;
    if (!Number.isNaN(numId)) {
      if (maxNumId === undefined) {
        maxNumId = numId;
      } else {
        maxNumId = Math.max(maxNumId, numId);
      }
    }
  });
  maxNumId = maxNumId === undefined ? 1 : maxNumId + 1;
  return String(maxNumId);
};
